import { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfStock } from '../../database/index';

import api from '../../services/api';
import { useAuth } from 'src/contexts/auth';
import { AxiosResponse } from 'axios';

export const useFormCreateStocks = () => {
    const { userAgencyId } = useAuth();
    const [loading, setLoading] = useState<boolean>(false);
    const [stockResponse, setStockResponse] = useState<AxiosResponse | null>(null);
    const [stockEditedResponse, setStockEditedResponse] = useState<AxiosResponse | null>(null);

    const history = useHistory();
    const toast: any = useRef();

    const validationSchema = Yup.object().shape({
        NOME: Yup.string().required('* Campo obrigatório'),
        ORGAOUNIDADE: Yup.string().required('* Campo obrigatório'),
    });

    const saveStock = async (stock: ModelOfStock) => {
        setLoading(true);

        const newStock: ModelOfStock = {
            ...stock,
            ORGAO: userAgencyId,
            TRAMITARPROPRIAUNIDADE: 1,
        };

        if (!!stockResponse) {
            api.put(`stocks/${stockResponse.data.ID}`, newStock)
                .then((response) => {
                    formik.resetForm();
                    setStockEditedResponse(response);
                    setStockResponse(null);
                    setLoading(false);
                    toast.current.show({
                        severity: 'success',
                        summary: 'Edição realizada',
                        detail: 'O estoque foi editada com sucesso!',
                        life: 5000,
                    });
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                    toast.current.show({
                        severity: 'error',
                        summary: 'Edição não realizado',
                        detail: 'Falha ao realizar operação!',
                        life: 5000,
                    });
                });
        } else {
            api.post('stocks', newStock)
                .then((response) => {
                    if (window.location.href === '/stockForm') history.push('/listStocks');
                    setLoading(false);
                    setStockResponse(response);
                    setStockEditedResponse(null);
                    toast.current.show({
                        severity: 'success',
                        summary: 'Cadastro realizado',
                        detail: 'Estoque cadastrado com sucesso!',
                        life: 5000,
                    });
                })
                .catch((err) => {
                    console.log(err);
                    setLoading(false);
                    toast.current.show({
                        severity: 'error',
                        summary: 'Cadastro não realizado',
                        detail: 'Falha ao realizar operação!',
                        life: 5000,
                    });
                });
        }
    };

    const formik = useFormik<ModelOfStock>({
        initialValues: {
            ORGAO: '',
            ORGAOUNIDADE: '',
            NOME: '',
            TRAMITARPROPRIAUNIDADE: 1,
        },
        onSubmit: async (values) => await saveStock(values),
        validationSchema,
    });

    return {
        getStockFormController: {
            formik,
            loading,
            toast,
            stockResponse,
            stockEditedResponse,
        },
        handleStockFormController: {
            setStockResponse,
            setStockEditedResponse,
        },
    };
};
